import { render, staticRenderFns } from "./MastersPage.vue?vue&type=template&id=121fb478&scoped=true&"
import script from "./MastersPage.vue?vue&type=script&lang=js&"
export * from "./MastersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121fb478",
  null
  
)

export default component.exports